// extracted by mini-css-extract-plugin
export var actions = "_t-0";
export var actionsContainer = "_t-6";
export var border = "_t-1";
export var childFullHeight = "_t-d";
export var collapse = "_t-2";
export var content = "_t-8";
export var contentChild = "_t-c";
export var fullscreen = "_t-a";
export var headerContainer = "_t-3";
export var headerRow = "_t-5";
export var hidePadding = "_t-9";
export var noScrollX = "_t-e";
export var noScrollY = "_t-f";
export var optOutTopPadding = "_t-b";
export var pagePadding = "_t-7";
export var profile = "_t-g";
export var profileContainer = "_t-h";
export var profileImage = "_t-i";
export var profileMain = "_t-j";
export var profileSubtitle = "_t-l";
export var profileTitle = "_t-k";
export var tabsWrapper = "_t-4";
export var title = "_t-m";